const API_KEY = 'AIzaSyC4qIiRSE0LGFCu1sGIfJ7nz64Xy06qkEQ';

const getSrc = ({
  latitude,
  longitude,
  zoom = 8,
  key = API_KEY,
}: {
  latitude: number;
  longitude: number;
  zoom?: number;
  key?: string;
}) => {
  return `https://www.google.com/maps/embed/v1/place?key=${key}
  &q=${latitude},${longitude}&zoom=${zoom}`;
};

const Map = ({
  latitude,
  longitude,
}: {
  latitude: number;
  longitude: number;
}) => (
  <iframe
    title='map'
    width='100%'
    height='100%'
    style={{
      border: 0,
    }}
    src={getSrc({
      latitude,
      longitude,
    })}
  ></iframe>
);

export default Map;
